import React, { FC, useCallback } from "react";
import { Button } from "../Button";
import { Image } from "../../Utility/MediaBuilder/Image";
import { Typography } from "../../Fundamentals/Typography";
import { Drawer } from "./Drawer";
import { IDrawerProps } from "./Drawer.interface";

export const SecurityCodeInfoDrawer: FC<IDrawerProps> = (props) => {
  const drawerContent = useCallback(
    (drawerProps) => (
      <>
        <div className="pt-8 px-6">
          <Typography variant="h3-pdp" classes={{ root: "mb-6" }} as="div">
            Find your CCV
          </Typography>
          <Typography
            variant="text-regular"
            classes={{ root: "mb-8" }}
            as="div"
          >
            3-digit security code usually can be found on the back of your
            physical credit card under the magnet tape.
          </Typography>
          <Image
            src="assets/images/checkout/cvv.png"
            classes={{ root: "mb-6 img-fluid" }}
            alt=""
          />
        </div>
        <div className="mt-auto mt-lg-0 py-5 px-6 bg-color-dark-blue bg-lg-transparent">
          <Button
            variant="secondary"
            classes={{ root: "w-100 w-lg-auto" }}
            type="button"
            onClick={drawerProps.close}
          >
            back to checkout
          </Button>
        </div>
      </>
    ),
    [],
  );
  return (
    <Drawer
      headerComponent={
        <div className="drawer__title text-uppercase">
          Where is the security code?
        </div>
      }
      render={drawerContent}
      {...props}
    />
  );
};
